import * as React from 'react'
import type { SVGProps } from 'react'
const SvgPencilWave = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M21 18s-1.334 1.5444-2.834 1.5444-2.7066-1.4294-4.1794-1.4294-2.3959.8042-2.9866 1.4294M18.5 7.5 6.8787 19.1213A3 3 0 0 1 4.7574 20H3v-1.7574a3 3 0 0 1 .8787-2.1213L15.5 4.5c.8284-.8285 2.1716-.8284 3 0s.8284 2.1716 0 3"
    />
  </svg>
)
export default SvgPencilWave
